import React, { ReactElement } from 'react';
import { message } from 'antd';
import SuccessAlert from 'components/Alert/SuccessAlert';
import ErrorAlert from 'components/Alert/ErrorAlert';
import { NotificationType } from 'contexts/notification.context';
import { NOTIFICATION } from 'components/Navigation/Layout';

export const alertErrorMessage = (messageString: string) => {
  message.config({ maxCount: 2 });
  message.error(<ErrorAlert messageString={messageString} />, 4);
  NOTIFICATION.addNotification({
    content: messageString,
    type: NotificationType.Error
  })
};

export const alertSuccessMessage = (messageEl: string | ReactElement) => {
  message.config({ maxCount: 2 });

  message.success(<SuccessAlert messageEl={messageEl} />, 4);
  NOTIFICATION.addNotification({
    content: messageEl,
    type: NotificationType.Success
  })
};
